const LoadingPost = ({
  index,
  className = '',
}: {
  index?: number;
  className?: string;
}) => {
  const animation =
    (index || 0) % 2 === 0
      ? `animate-pulse`
      : `animate-pulse [animation-delay:-0.1s]`;
  return (
    <div className={`${className} p-4`}>
      <div className={`flex gap-3`}>
        {/* Avatar column - flex-[1] to match PostItem */}
        <div className={`flex-[1]`}>
          <div
            className={`w-full aspect-square rounded-full bg-gray-300 ${animation}`}
          />
        </div>

        {/* Content column - flex-[7] to match PostItem */}
        <div className={`flex-[7] flex flex-col`}>
          {/* Nickname - default Text size */}
          <div
            className={`rounded-xl h-5 w-1/2 bg-gray-300 ${animation}`}
          ></div>
          
          {/* Date/Time - mt-1 to match PostItem */}
          <div
            className={`mt-1 rounded-xl h-4 w-1/3 bg-gray-300 ${animation}`}
          ></div>
          
          {/* Post content - mt-2 to match PostItem */}
          <div
            className={`mt-2 rounded-xl h-32 bg-gray-300 ${animation}`}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPost;
